import roles from '@/utils/constants/roles.js';
const getters = {
  getCompanies: (state, getters, rootState) => {
    return rootState['$_user'].companies;
  },
  getUserCompanyId: (state, getters, rootState) => {
    return rootState['$_user'].user.profile.companyid;
  },
  hasProviderSingleCompany(state, getters, rootState) {
    return (
      rootState['$_user'].companies != null &&
      rootState['$_user'].companies.length <= 1
    );
  },
  canViewOnlyPreliminarStatus(state, getters, rootState) {
    return [
      roles.AdminProvider,
      roles.Provider,
      roles.Administrador,
      roles.AdminSAEE,
      roles.AdminIL,
      roles.ProviderCPA,
    ].includes(rootState['$_user'].user.profile.role);
  },
  getBillingResultsPaginationConfig: (state) =>
    state.billingSearchResults.paginationConfig,
  getMinYearId: (state) => state.minYearId,
  getReasons(state) {
    return state.adjustmentDetails.reasons.map((item) => {
      return {
        id: item.id,
        name: item.name,
      };
    });
  },
  getCostbyReasonId: (state) => (id) => {
    const reason = state.adjustmentDetails.reasons.find(
      (item) => item.id == id
    );
    if (reason) {
      return parseFloat(reason.cost)
        .toFixed(2)
        .toString();
    }
    return '';
  },
};
export default getters;
